/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_QUESTION } from "./actionTypes"
import { apiError, addQuestionSuccess } from "./actions"

//Include Both Helper File with needed methods
import { addQuestion } from "../../../helpers/backend_helper"

function* add(request) {
  try {
    const response = yield call(addQuestion, request.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(addQuestionSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* questionAddSaga() {
  yield takeEvery(ADD_QUESTION, add)
}

export default questionAddSaga
